import { ASSETS } from '../../../assets';
import copy from '../../../copy.json';
import './styles.scss';

const WhyKeyes2SafetyDesktop = () => {
    const CLASS_NAME = "why-keyes-2-safety-desktop";
    const whyKeyes2SafetyCopy = copy.whyKeyes2Safety;
    const renderText = (textArray: string[]) => textArray.map((text, index) => <p className={`${CLASS_NAME}-text`} key={index}>{text}</p>)

    return <div className={CLASS_NAME}>
        <div className={`${CLASS_NAME}-container`}>
            <img src={ASSETS.WHY_KEYES_2_SAFETY_BANNER} alt="Why Keyes2Safety Banner" />
            <div className={`${CLASS_NAME}-content`}>
                <h2>{whyKeyes2SafetyCopy.header}</h2>
                {renderText(whyKeyes2SafetyCopy.summary)}
                <hr />
                <h2>{whyKeyes2SafetyCopy.differentiators.header}</h2>
                {renderText(whyKeyes2SafetyCopy.differentiators.text)}
                <hr />
                <h2>{whyKeyes2SafetyCopy.benefits.header}</h2>
                {renderText(whyKeyes2SafetyCopy.benefits.text)}
            </div>
        </div>
    </div>
}

export default WhyKeyes2SafetyDesktop;